import cookieJs from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import instance from "../axios_setup/instance";
// imports module css
import { UserContex } from "./App2";
import Classes from "./style/signUp.module.css";

/*---------------------SignUp From components------------- */

export default function SignUpFrom() {
  // for navigate to home
  const navigate = useNavigate();
  const { dispatch } = useContext(UserContex);
  //
  const debounce = (func, delay) => {
    setTimeout(() => {
      func();
    }, delay);
  };
  //
  const [permission, setPermission] = useState(false);
  const [loading, setLoading] = useState(false);
  const [avatar, setAvatar] = useState("");
  const [state, setState] = useState({
    name: "",
    number: "",
    email: "",
    password: "",
    cPassword: "",
  });
  // handle err state
  const [nameError, setNameError] = useState("");
  const [numberError, setNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [pwError, setPwError] = useState("");
  const [confirmPwError, setCnfirmPwErro] = useState("");
  const [avatarError, setAvatarError] = useState("");
  const [premitionError, setPermissionError] = useState("");
  let name, value;
  // tostify is here

  // onChange function
  const onChangeFun = (e) => {
    // console.log(e.target.value)
    name = e.target.name;
    value = e.target.value;

    setState({ ...state, [name]: value });
  };
  const onSubmitFun = async (event) => {
    event.preventDefault();

    const { name, email, number, password, cPassword } = state;
    const obj = {
      name: name,
      number: number,
      email: email,
      password: password,
      cPassword: cPassword,
      avatar: avatar,
      permission: permission,
    };
    const fromData = new FormData();
    fromData.append("name", obj.name);
    fromData.append("number", obj.number);
    fromData.append("email", obj.email);
    fromData.append("password", obj.password);
    fromData.append("cPassword", obj.cPassword);
    fromData.append("avatar", obj.avatar);
    fromData.append("permission", obj.permission);

    const url = "/reg";
    try {
      setLoading(true);
      const { data } = await instance.post(url, fromData);
      const { decoded } = data.success;

      setPermissionError("");
      if (!data.errors) {
        setNameError("");
        setNumberError("");
        setEmailError("");
        setCnfirmPwErro("");
        setAvatarError("");
        setPermissionError("");
        cookieJs.set("furniture_shop", decoded, { secure: true });
        //    success tost
        toast.success("Registration Successful...🔥", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        // debounce acctually it's not debouce 😁
        debounce(function () {
          // call  dispatch funtion
          dispatch({ type: "USER", payload: true });
          setLoading(false);
          navigate("/home", { replace: true });
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      const { response } = err;
      const { data } = response;
      const { errors } = data;
      console.log(data);
      const { msg } = errors;

      const msgArray = Object.keys(msg);
      /* -------------- for name ------------*/
      if (msgArray.includes("name")) {
        setNameError(msg.name.msg);
      } else {
        setNameError("");
      }
      /* -------------- for number ------------*/
      if (msgArray.includes("number")) {
        setNumberError(msg.number.msg);
      } else {
        setNumberError("");
      }
      /* -------------- for email ------------*/
      if (msgArray.includes("email")) {
        setEmailError(msg.email.msg);
      } else {
        setEmailError("");
      }
      /* -------------- for password ------------*/
      if (msgArray.includes("password")) {
        setPwError(msg.password.msg);
      } else {
        setPwError("");
      }
      /* -------------- for Confirm passeord ------------*/
      if (msgArray.includes("cPassword")) {
        setCnfirmPwErro(msg.cPassword.msg);
      } else {
        setCnfirmPwErro("");
      }
      /* -------------- for avatar ------------*/
      if (msgArray.includes("avatar")) {
        setAvatarError(msg.avatar.msg);
      } else {
        setAvatarError("");
      }
      /* -------------- for Permission ------------*/
      if (msgArray.includes("permission")) {
        setPermissionError(msg.permission.msg);
      } else {
        setPermissionError("");
      }
      // toastfy
      toast.error("Registration Falid..😫!", {
        position: "top-center",
        autoClose: 500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <>
      <form onSubmit={onSubmitFun} className="mx-1 mx-md-4" id={Classes.signUp}>
        <div className="d-flex flex-row align-items-center mb-1">
          <i className="fas fa-user fa-lg me-3 fa-fw"></i>
          <div className="form-outline flex-fill mb-0">
            <input
              type="text"
              id="form3Example1c1"
              className={`form-control ${Classes.signUpInput}`}
              placeholder="enter your name"
              name="name"
              value={state.name}
              onChange={onChangeFun}
              autoComplete="off"
              required
            />

            <label className="form-label" htmlFor="form3Example1c1">
              Your Name
              <p className="name error" style={{ display: "inline" }}>
                {nameError}
              </p>
            </label>
          </div>
        </div>
        <div className="d-flex flex-row align-items-center mb-1">
          <i className="fas fa-address-book fa-lg me-3 fa-fw"></i>
          <div className="form-outline flex-fill mb-0">
            <input
              type="text"
              id="form3Example1c"
              className={`form-control ${Classes.signUpInput}`}
              placeholder="enter mobile no"
              name="number"
              value={state.number}
              onChange={onChangeFun}
              autoComplete="off"
              required
            />
            <label className="form-label" htmlFor="form3Example1c">
              Number
              <p className="number error" style={{ display: "inline" }}>
                {numberError}
              </p>
            </label>
          </div>
        </div>

        <div className="d-flex flex-row align-items-center mb-1">
          <i className="fas fa-envelope fa-lg me-3 fa-fw"></i>
          <div className="form-outline flex-fill mb-0">
            <input
              type="email"
              id="form3Example3c"
              className={`form-control ${Classes.signUpInput}`}
              placeholder="example@gmail.com"
              name="email"
              value={state.email}
              onChange={onChangeFun}
              autoComplete="off"
              required
            />
            <label className="form-label" htmlFor="form3Example3c">
              Email
              <p className="email error" style={{ display: "inline" }}>
                {emailError}
              </p>
            </label>
          </div>
        </div>

        <div className="d-flex flex-row align-items-center mb-1">
          <i className="fas fa-lock fa-lg me-3 fa-fw"></i>
          <div className="form-outline flex-fill mb-0">
            <input
              type="password"
              id="form3Example4c"
              className={`form-control ${Classes.signUpInput}`}
              placeholder="enter a strong password"
              name="password"
              value={state.password}
              onChange={onChangeFun}
              autoComplete="off"
              required
            />
            <label className="form-label" htmlFor="form3Example4c">
              Password
              <p className="password error" style={{ display: "inline" }}>
                {pwError}
              </p>
            </label>
          </div>
        </div>

        <div className="d-flex flex-row align-items-center mb-1">
          <i className="fas fa-key fa-lg me-3 fa-fw"></i>
          <div className="form-outline flex-fill mb-0">
            <input
              type="password"
              id="form3Example4cd"
              className={`form-control ${Classes.signUpInput}`}
              placeholder="confirm password"
              name="cPassword"
              value={state.cPassword}
              onChange={onChangeFun}
              autoComplete="off"
              required
            />
            <label className="form-label" htmlFor="form3Example4cd">
              confirm password
              <p className="cPassword error" style={{ display: "inline" }}>
                {confirmPwError}
              </p>
            </label>
          </div>
        </div>
        <div className="mb-3 d-flex justify-content-center align-items-center">
          <i
            className="fa-regular fa-image"
            style={{ marginRight: "0.6rem", fontSize: "1.5rem" }}
          ></i>
          <input
            className={`form-control form-control-sm ${Classes.signUpInput}`}
            id="formFileSm"
            type="file"
            name="avatar"
            onChange={(e) => setAvatar(e.target.files[0])}
            autoComplete="off"
            // required
          />
          <p className="avatar error" style={{ display: "inline" }}>
            {avatarError}
          </p>
        </div>

        <div className="form-check d-flex justify-content-flex-start mb-1">
          <small>
            <input
              type="checkbox"
              className="form-check-input signUpInput"
              id="premition"
              name="permission"
              value={permission}
              onChange={(e) => setPermission(e.target.checked)}
              required
            />
          </small>
          <label
            style={{ paddingLeft: "2.5rem" }}
            className="form-check-label"
            htmlFor="premition"
          >
            <small>
              <b>
                apply theme's & condition
                <p className={`permission error`} style={{ display: "inline" }}>
                  {premitionError}
                </p>
              </b>
            </small>
          </label>
        </div>

        <div className="d-flex mx-4 mt-4 mb-lg-3">
          <button
            type="submit"
            className={Classes.btnSignup}
            disabled={loading}
            // onClick={onSubmitFun}
          >
            {loading ? "Wait..." : "Sign Up"}
          </button>
        </div>
        <br />
        <br />
        <small>
          Already have account?
          <NavLink to="/login/" className="text-danger">
            Go to login
          </NavLink>
        </small>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </form>
    </>
  );
}
